
export type FeatureKey = string;
export type FeatureConfig = Record<string, any>;
export type FeatureValue = Exclude<FeatureConfig | typeof STANDARD_FEATURE, string>;
type Features = { [key: string]: FeatureValue };
export interface IFeatureSet extends Features {
    StandardFeature: typeof STANDARD_FEATURE,
}

const STANDARD_FEATURE = Symbol();
const FeatureSetBase = {
    StandardFeature: STANDARD_FEATURE as typeof STANDARD_FEATURE
};

export function FeatureSet<T extends { [key: string]: FeatureValue }>(features: T): typeof FeatureSetBase & T {
    return Object.create(FeatureSetBase, Object.getOwnPropertyDescriptors(features));
};
FeatureSet.StandardFeature = STANDARD_FEATURE;

/**
 * A set of feature flags available to the application.
 * @enum
 */
export const Features = FeatureSet({
    FeatureFlags: {},
    // INFO [Matt] Add new feature flags here. The value of each flag should be
    //  an object. In future iterations, we may add options to each feature
    //  within the object.
    // EXAMPLE [Matt]
    // NewFeature: {}
});
